import { render, staticRenderFns } from "./VoucherCancel.vue?vue&type=template&id=c6eaf4b4&"
import script from "./VoucherCancel.vue?vue&type=script&lang=js&"
export * from "./VoucherCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6eaf4b4')) {
      api.createRecord('c6eaf4b4', component.options)
    } else {
      api.reload('c6eaf4b4', component.options)
    }
    module.hot.accept("./VoucherCancel.vue?vue&type=template&id=c6eaf4b4&", function () {
      api.rerender('c6eaf4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Vouchers/VoucherCancel.vue"
export default component.exports